import ValidService from "@/service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  dai_ly_id: undefined, // required, ref: agt_dai_ly - Mã tỉnh
  tinh_id: undefined, // required, ref: province - Mã tỉnh
  cap_id: undefined, // required, ref: agt_cap - Mã cấp đại lý
  chiet_khau_co_dinh: undefined, // required - Có cho đại lý tự thay đổi chiết khấu riêng
  chiet_khau: [
    // optional - Danh sách các giá trị chiết khấu cố định
    {
      san_pham_id: undefined, // optional, ref: prd_san_pham - Mã sản phẩm
      gia_tri: undefined, // optional, min: 0 - Giá trị (%)
    },
  ],
  chinh_thuc: undefined, // optional - Có phải đại lý tỉnh chính thức không
  hieu_luc: undefined, // optional - Có kích hoạt không?
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao,-id",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  fields:
    "id,dai_ly_id,tinh_id,cap_id,chiet_khau_co_dinh,chiet_khau,chinh_thuc,hieu_luc,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",

  dataSearch: {
    value: {
      ten: "",
      trang_thai: "",
    },
    operator: {
      ten: ":regex_i:",
      trang_thai: "",
    },
  },
};

export default model;
